import React, { Component } from 'react';
import axios from 'axios'
import { serverIp } from '../../../../config/constants'
import {  Modal, Button, Divider, } from 'semantic-ui-react'
import * as UiConsts from '../../../../config/UiConstants';

import createBrowserHistory from 'history/createBrowserHistory';
const history = createBrowserHistory({ forceRefresh: true });

class DeleteItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            orderStatuses: [],
            status: '', 
            modalOpen: false,
        }
    }

    componentDidMount() {
        console.log("++++++++:componentDidMount");
    }


    openModal = () => {
        this.setState({ modalOpen: true });
    }

    closeModal = () => {
        this.setState({ modalOpen: false });

    }

    deleteItem = () => {
        // SEND CHECK TO SERVER

        this.setState({ loading: true })

        axios.post(serverIp + "large_project_items/deleteLargeProjectItem", {
            apiKey: "deleteLargeProjectItem",
            enteredBy: this.props.user.email,
            largeProjectItemId: this.props.largeProjectItemId
        })
            .then((response) => {

                console.log(response.data);

                if (response.data.result) {
                    console.log("true.. ");

                    this.setState({
                        loading: false
                    })

                    this.props.refresh();
                    alert(response.data.message);
                    //history.push("/dashboard/viewLargeProject/" + this.props.projectId);
                } else {
                    console.log("FAILED");
                    alert(response.data.message);
                }
            })
            .catch((error) => {
                console.log(error);
                alert("FAILED TO LOAD ITEMS");
                this.setState({
                    loading: false
                })
            });
    }


    render() {

        const deleteUi =
            <div>
                <Divider horizontal>{'DELETE THIS ORDER'}</Divider>

                <Modal size={'mini'} open={this.state.modalOpen} onClose={this.close}>
                    <Modal.Header>
                       Delete Item
    </Modal.Header>
                    <Modal.Content>
                        <p>Are you sure you delete this item? IT CANNOT BE REVERSED!! MAKE SURE!!</p>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button negative onClick={this.closeModal}>
                            No
        </Button>
                        <Button positive icon='checkmark' labelPosition='right' content='Yes' onClick={this.deleteItem} />
                    </Modal.Actions>
                </Modal>

                <Button color='red' fluid onClick={this.openModal} >DELETE ITEM </Button>
            </div>


        return (this.state.loading ? <UiConsts.LoadingComponent /> : <div>
            {deleteUi}

        </div>);
    }
}

export default DeleteItem;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/LargeProjectOrderEntry/DeleteItem.js